import { useQuery } from "@tanstack/react-query";
import { api, money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { format } from "date-fns";

export default function AdminSubscriptions() {
  const { data } = useQuery({
    queryKey: ["admin-subscriptions"],
    queryFn: async () => (await api.get("/admin/subscriptions")).data,
  });
  const subs = data?.subscriptions || [];

  return (
    <div data-testid="admin-subscriptions-page">
      <p className="text-xs text-muted-foreground mb-3">{data?.note}</p>
      <Card className="bg-card border-border overflow-x-auto">
        <div className="min-w-[760px]">
          <div className="grid grid-cols-12 gap-2 px-4 py-3 border-b border-border overline text-muted-foreground">
            <span className="col-span-3">User</span><span className="col-span-2">Plan</span>
            <span className="col-span-2">Status</span><span className="col-span-2">Signup</span>
            <span className="col-span-2">Next Billing</span><span className="col-span-1 text-right">MRR</span>
          </div>
          {subs.map((s) => (
            <div key={s.id} data-testid={`sub-row-${s.id}`}
              className="grid grid-cols-12 gap-2 px-4 py-3 border-b border-border last:border-0 items-center text-sm">
              <span className="col-span-3 truncate"><span className="font-medium">{s.name}</span><span className="block text-xs text-muted-foreground truncate">{s.email}</span></span>
              <span className="col-span-2">
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${s.plan === "Pro" ? "bg-primary/20 text-primary" : "bg-secondary text-muted-foreground"}`}>{s.plan}</span>
              </span>
              <span className="col-span-2 text-muted-foreground">{s.status}</span>
              <span className="col-span-2 text-muted-foreground text-xs">{s.signup_date ? format(new Date(s.signup_date), "MMM d, yyyy") : "—"}</span>
              <span className="col-span-2 text-amber-400/80 text-xs italic">Pending Stripe integration</span>
              <span className="col-span-1 text-right font-semibold">{s.mrr ? money(s.mrr, "USD") : "—"}</span>
            </div>
          ))}
          {subs.length === 0 && <div className="p-8 text-center text-muted-foreground">No subscriptions.</div>}
        </div>
      </Card>
    </div>
  );
}
